import styled from 'styled-components'

export default styled.div`
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  font-size: 1.4rem;

  .item-image {
    max-width: 10rem;
    max-height: 10rem;
  }

  .left {
    text-align: left;
  }
  .right {
    text-align: right;
  }

  .content {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 4rem;

    .content-item {
      table {
        border-collapse: collapse;
        width: 26rem;

        thead {
          tr {
            th {
              border-bottom: 1px solid #000;
              padding-bottom: 0.5rem;
            }
          }
        }

        tbody {
          tr {
            td {
              padding-top: 0.5rem;
            }
          }
        }
      }

      .content-item-highlight {
        font-weight: bold;
        text-align: center;
      }
    }
  }

  @media (min-width: 576px) {
    max-width: 540px;
  }
  @media (min-width: 768px) {
    max-width: 720px;
  }
  @media (min-width: 992px) {
    max-width: 960px;
  }
  @media (min-width: 1270px) {
    max-width: 1240px;

    .content-item {
      max-width: 50rem;
    }
  }

  .flex_wrap {
    display: flex;
    flex-wrap: wrap;
  }

  .align_center {
    align-items: center;
  }

  .justify_center {
    justify-content: center;
  }

  .icon_button {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    background-color: transparent;
    border: 0;
    outline: none;
    cursor: pointer;
    border-radius: 1rem;
    padding: 1rem;
    font-weight: bold;

    &:hover {
      background-color: #e9e9e9;
    }

    img {
      width: 8rem;
      margin-bottom: 0.5rem;
    }
  }

  .bold {
    font-weight: bold;
    padding-left: 1rem;
  }
`

export const ModalContainer = styled.div`
  font-size: 1.4rem;

  h3 {
    font-size: 2.4rem;
    color: #6a6a6a;
    margin-top: 1rem;
    margin: 0;
  }

  .price {
    font-size: 2.4rem;
    font-weight: bold;
    text-align: center;
  }

  .total {
    font-size: 3.2rem;
    border-top: 1px solid #000;
    width: 100%;
    text-align: center;
    padding-top: 0.5rem;
  }

  .footer {
    text-align: center;
    font-size: 1.6rem;
  }

  .footer_price {
    text-align: center;
    font-size: 1.8rem;
    font-weight: bold;
    margin-top: 0.5rem;
  }

  .purchase_info {
    font-size: 1.6rem;
    text-align: center;
    max-width: 40rem;
  }

  .pack {
    width: 100%;
    cursor: pointer;
    text-align: center;
    border: 2px solid #000;
    border-radius: 0.5rem;
    padding: 1rem;

    &:hover {
      background: #e41645;
      color: white;
      border-color: #e41645;
    }

    .pack-value {
      font-weight: bold;
      font-size: 2rem;
    }
  }

  .saving {
    width: 100%;
    text-align: right;
    font-size: 1.6rem;
    font-weight: bold;
    padding-right: 18%;
    color: #e41645;
  }

  .message_text {
    font-size: 1.6rem;
    text-align: center;
    padding-bottom: 15px;

    &.success {
      color: #09ad37;
    }
    &.error {
      color: #ad0909;
    }
  }
`
